export const isPlanInvalid = (plan) => {
  return !plan.billing || plan.value === '' || plan.valuePerStaff === '' || plan.staffLimit <= 0
}
